
function NoAccess() {
  window.location.replace(import.meta.env.VITE_NO_ACCESS_URL as string);
  return null;
}

export default NoAccess;
